import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { Home } from '@/components/features/home/Home';
import { FilePreviewModal } from '@/features/file-preview/FilePreviewModal';

const homeSearchSchema = z.object({
  /** Program to preview in a modal — set when a PROGRAM notification is opened from an OS notification. */
  previewProgramId: z.string().optional().catch(undefined),
  previewFilename: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_protected/t/$tenantId/')({
  ssr: true,
  validateSearch: homeSearchSchema,
  component: HomePage,
});

function HomePage() {
  const { previewProgramId, previewFilename } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <>
      <Home />
      {previewProgramId && (
        <FilePreviewModal
          isOpen
          programId={previewProgramId}
          filename={previewFilename ?? ''}
          onClose={() =>
            void navigate({
              search: (prev) => ({ ...prev, previewProgramId: undefined, previewFilename: undefined }),
              replace: true,
            })
          }
        />
      )}
    </>
  );
}
